import { render } from "./DeleteCategoriesModal.vue?vue&type=template&id=0fece2c6"
import script from "./DeleteCategoriesModal.vue?vue&type=script&lang=js"
export * from "./DeleteCategoriesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__